/**
 * In-memory store for the studies-service user id injected by the shell
 * via postMessage. Used so the legacy app can identify to Segment/Mixpanel
 * with the same id as the shell, giving a unified distinct_id across apps.
 */

let _userId: string | null = null;

/** Called by CommunicationBridgeProvider when the shell sends a user id. */
export function setUserId(id: string) {
	_userId = id;
}

/** Returns the current user id, or null if not yet received. */
export function getUserId(): string | null {
	return _userId;
}
